import React from 'react';
import CompactCheckboxDropdown, { Option } from "./CompactCheckboxDropdown";

// --- Types ---
interface BaseFilterProps {
  options: Option[];
  onChange: (value: string[]) => void;
  loading?: boolean;
  enableSelectAll?: boolean;
  selectAllLabel?: string;
}

interface DistributorTypeFilterProps extends BaseFilterProps {
  value: string[];
}

interface DivisionFilterProps extends BaseFilterProps {
  value: string[];
}

// --- Components ---

export const DistributorTypeFilter: React.FC<DistributorTypeFilterProps> = ({
  value,
  options,
  onChange,
  loading,
  enableSelectAll = false,
  selectAllLabel,
}) => {
  const selectedValues = Array.isArray(value) ? value : [];
  return (
    <CompactCheckboxDropdown
      label="Distributor Type"
      options={options}
      selectedValues={selectedValues}
      onChange={onChange}
      placeholder="Select here"
      width={170}
      loading={loading}
      dropdownWidth={210}
      enableSelectAll={enableSelectAll}
      selectAllLabel={selectAllLabel}
    />
  );
};

export const DivisionFilter: React.FC<DivisionFilterProps> = ({
  value,
  options,
  onChange,
  loading,
  enableSelectAll = false,
  selectAllLabel,
}) => {
  const selectedValues = Array.isArray(value) ? value : [];
  return (
    <CompactCheckboxDropdown
      label="Distributor Division"
      options={options}
      selectedValues={selectedValues}
      onChange={onChange}
      placeholder="Select here"
      loading={loading}
      width={170}
      dropdownWidth={210}
      enableSelectAll={enableSelectAll}
      selectAllLabel={selectAllLabel}
    />
  );
};

